// extracted by mini-css-extract-plugin
export default {"map":"_0aYKV0G1--Map_map__1HBdJ","wiggle":"_0aYKV0G1--Map_wiggle__5JsYw","shimmer":"_0aYKV0G1--Map_shimmer__yJyNx"};